(() => {
 document.addEventListener('click', event => {
  const button = event.target.closest?.('#AddToCart');
  if (!button || button.disabled || event.defaultPrevented || event.button !== 0) return;
  const form = button.closest('form');
  if (!form || !form.checkValidity() || matchMedia('(prefers-reduced-motion: reduce)').matches || !Element.prototype.animate) return;
  const sticky = document.querySelector('.drain-mobile-buy:not([hidden]) .drain-mobile-buy__button');
  const anchor = !event.isTrusted && sticky ? sticky : button;
  let burst;
  try {
   const box = anchor.getBoundingClientRect();
   burst = document.createElement('span');
   burst.className = 'drain-shop-burst drain-heat-burst drain-cart-explosion';
   burst.setAttribute('aria-hidden', 'true');
   burst.style.left = (box.left + box.width / 2) + 'px';
   burst.style.top = (box.top + box.height / 2) + 'px';
   document.body.append(burst);
   setTimeout(() => burst.remove(), 650);
   for (let i = 0; i < 22; i++) {
    const spark = document.createElement('i');
    const angle = i * Math.PI * 2 / 22;
    const radius = 42 + (i % 4) * 14;
    burst.append(spark);
    spark.animate([
     {transform:'translate(0,0) scale(.3)',opacity:1},
     {transform:`translate(${Math.cos(angle)*radius}px,${Math.sin(angle)*radius*.65-15}px) scale(1.1)`,opacity:1,offset:.3},
     {transform:`translate(${Math.cos(angle)*radius*1.4}px,${Math.sin(angle)*radius-35}px) scale(0)`,opacity:0}
    ], {duration:550,easing:'ease-out',fill:'forwards'});
   }
  } catch (_) { if (burst) burst.remove(); }
 }, true);
 document.addEventListener('pointerdown', event => {
  const link = event.target.closest?.('a.drain-card-shop');
  if (!link || event.button !== 0) return;
  link.classList.add('drain-shop-pressed');
  setTimeout(() => link.classList.remove('drain-shop-pressed'), 220);
 });
 addEventListener('pageshow', () => document.querySelectorAll('.drain-shop-pressed').forEach(node => node.classList.remove('drain-shop-pressed')));
})();
